const name = 'circle-9';


const contents = `
<circle cx="31" cy="41" r="29"/>
<path d="M30.876 26.5c1.933 0 3.576.359 4.93 1.077a9.347 9.347 0 013.314 2.9c.856 1.215 1.478 2.624 1.864 4.226.387 1.602.58 3.259.58 4.971 0 3.094-.359 5.648-1.077 7.665-.718 2.016-1.67 3.631-2.858 4.847-1.188 1.215-2.569 2.071-4.143 2.568a16.274 16.274 0 01-4.93.746c-1.436 0-2.555-.097-3.356-.29a30.625 30.625 0 01-2.859-.87l.663-4.06c1.216.387 2.21.649 2.983.787.773.138 1.602.207 2.486.207 1.326 0 2.444-.29 3.356-.87a8.633 8.633 0 002.32-2.154 8.928 8.928 0 001.408-2.859c.304-1.05.511-2.043.622-2.982l-.498-.083c-.773 1.05-1.657 1.892-2.651 2.527-.994.635-2.127.953-3.397.953-2.652 0-4.847-.801-6.587-2.403-1.74-1.602-2.61-3.977-2.61-7.126 0-3.093.994-5.496 2.983-7.208 1.988-1.713 4.474-2.569 7.457-2.569zm-.083 4.391c-1.326 0-2.458.456-3.397 1.368-.94.911-1.409 2.168-1.409 3.77 0 .607.07 1.229.207 1.864a4.89 4.89 0 00.746 1.74c.359.525.87.966 1.533 1.326.663.359 1.491.538 2.486.538.994 0 1.933-.248 2.817-.746.883-.497 1.601-1.104 2.154-1.822 0-.995-.055-1.975-.166-2.942-.11-.967-.344-1.823-.704-2.568a4.56 4.56 0 00-1.574-1.823c-.69-.47-1.588-.705-2.693-.705z" fill="#FFF"/>
`;


/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: '9',
};

export default icon;
